import React, { useState } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { TrustBuilder } from '../components/TrustBuilder';
import { WhatWeDoSection } from '../components/WhatWeDoSection';
import { PlatformShowcase } from '../components/PlatformShowcase';
import { StatsSection } from '../components/StatsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
import { DemoModal } from '../components/DemoModal';
import { Footer } from '../components/Footer';
export function LandingPage() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  return <main className="min-h-screen w-full bg-stark-white overflow-x-hidden" data-id="element-301" data-mp="2fz46k9wuamck">
      <Header onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-302" data-mp="qkplbzl15hlt" />
      <HeroSection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-303" data-mp="ql92he2uw1ys" />
      <TrustBuilder data-id="element-304" data-mp="lm60k2i6abv1" />
      <WhatWeDoSection data-id="element-305" data-mp="lmxt14gh3th3" />
      <PlatformShowcase onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-306" data-mp="lnh3k03snfl3" />
      <StatsSection data-id="element-307" data-mp="2zjyn5v6u4klz" />
      <TestimonialsSection data-id="element-308" data-mp="2zkrv2zhj5g5p" />
      <CTASection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-309" data-mp="33kigsos7963d" />
      <Footer data-id="element-310" data-mp="33l1wdyudnie8" />

      <DemoModal isOpen={isDemoModalOpen} onClose={() => setIsDemoModalOpen(false)} data-id="element-311" data-mp="33ifticiflr2c" />
    </main>;
}